export const GET_PASSPORT_VERIFICATION = 'GET_PASSPORT_VERIFICATION'
export const GET_PASSPORT_VERIFICATION_LOADING = 'GET_PASSPORT_VERIFICATION_LOADING'
export const GET_PASSPORT_VERIFICATION_SUCCESS = 'GET_PASSPORT_VERIFICATION_SUCCESS'
export const GET_PASSPORT_VERIFICATION_ERROR = 'GET_PASSPORT_VERIFICATION_ERROR'

export const getPassportVerificationStatus = (body) => ({ type: GET_PASSPORT_VERIFICATION, body });
export const clearPassportVerificationStatus = () => ({ type: GET_PASSPORT_VERIFICATION_SUCCESS, body : {} });